import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './common/store/store';
import './assets/scss/app.scss';

import * as Sentry from '@sentry/react';

import App from './App';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || 'dev',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

if (import.meta.env.VITE_VERSION) console.log(`App version: ${import.meta.env.VITE_VERSION}`);

// Google Tag Manager — only in production, not in demo
if (import.meta.env.VITE_ENV === 'prod' && !import.meta.env.VITE_DEMO) {
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-ND2J4VQ';
  document.head.appendChild(script);
  const w = window as Window & { dataLayer: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
